import { render } from "./ModalRemove.vue?vue&type=template&id=75cf4d1c&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"

import "./ModalRemove.vue?vue&type=style&index=0&id=75cf4d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cf4d1c"]])

export default __exports__